import branchManagementBypassCodeComponent from './bypass_code.component';

let branchManagementBypassCodeModule = angular.module('branchManagementBypassCode', [])
  .component('branchManagementBypassCode', branchManagementBypassCodeComponent)
  .name;

export default branchManagementBypassCodeModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bypass_code/index.js